import { render, staticRenderFns } from "./ViewAudit.vue?vue&type=template&id=63ed5b4f"
import script from "./ViewAudit.vue?vue&type=script&lang=js"
export * from "./ViewAudit.vue?vue&type=script&lang=js"
import style0 from "./ViewAudit.vue?vue&type=style&index=0&id=63ed5b4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports